import React, { useEffect, useRef } from 'react';
import {
    Button,
    InputControl,
    Container,
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    ButtonGroup,
    Col,
    Row,
} from '@si-armes/dsfr-react';
import { useForm } from 'react-hook-form';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_RECUPER_LOGIN_DEMANDE,
    CONTEXT_RECUPER_LOGIN_DEMANDE,
} from '../../../../constants/apiUrls.constants';
import { REGEXP_EMAIL } from '../../../../constants/contraintes.constants';
import InfoChampsObligatoire from '../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const DemandeLoginOublie = ({ postApi, reinitialiseApi, erreur, message, isLoading }) => {
    const { register, handleSubmit, formState } = useForm({
        mode: 'onChange',
        criteriaMode: 'all',
    });

    const redirigerVersAccueil = () => {
        window.location.href = process.env.REACT_APP_HOST;
    };

    useEffect(() => {
        return () => {
            reinitialiseApi(CONTEXT_RECUPER_LOGIN_DEMANDE);
        };
    }, []);

    const onSubmit = (messageForm) => {
        postApi(
            usagerClientReducer,
            API_RECUPER_LOGIN_DEMANDE.replace('{email}', messageForm.email),
            {},
            CONTEXT_RECUPER_LOGIN_DEMANDE,
        );
    };

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <Container>
            {!isLoading && !erreur && message && (
                <ModalV2
                    id="recuperationLogin"
                    idModalTitle="recuperationLogin-title"
                    onClose={redirigerVersAccueil}
                    size="sm"
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="recuperationLogin-title">
                            Récupération de Login
                        </ModalV2Title>
                        {message}
                    </ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup align="right" inline>
                            <Button variant="primary" onClick={redirigerVersAccueil}>
                                Retour à la page de connexion
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )}

            <h1 className="text-center majuscule">Identifiant Oublié</h1>
            <div className="bordure">
                <h2 className="font-size-md text-center margin-top-sm margin-bottom-md">
                    Vous avez perdu votre identifiant. Veuillez suivre la procédure ci-dessous pour
                    le récupérer
                </h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row gutters horizontalAlign="center" className="margin-bottom-md">
                        <Col col={12} md={8}>
                            <InfoChampsObligatoire />
                        </Col>
                        <Col col={12} md={8}>
                            <InputControl
                                id="email"
                                autocomplete="email"
                                label="Veuillez saisir votre courriel *"
                                type="text"
                                required
                                {...register('email', {
                                    required: 'Le champ est obligatoire',
                                    pattern: {
                                        value: REGEXP_EMAIL,
                                        message: "Le format de l'adresse courriel n'est pas valide",
                                    },
                                })}
                                state={formState.errors?.email ? 'error' : null}
                                message={formState.errors?.email?.message}
                            />
                        </Col>
                    </Row>
                    <ButtonGroup inline align="right">
                        <Button
                            name="retour-accueil"
                            variant="secondary"
                            onClick={redirigerVersAccueil}
                        >
                            Annuler
                        </Button>
                        <Button
                            name="valider"
                            variant="primary"
                            type="submit"
                            disabled={!formState.isValid}
                            isLoading={isLoading}
                        >
                            Valider
                        </Button>
                    </ButtonGroup>
                </form>
            </div>
        </Container>
    );
};

DemandeLoginOublie.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    erreur: PropTypes.bool,
    message: PropTypes.string,
};

export default connect(
    (state) => {
        const { erreur, message, isLoading } = state.compte.recupererLogin.demande;
        return {
            erreur,
            message,
            isLoading,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(DemandeLoginOublie);
